<label id="label-input">
    <span>Senha:</span>
    <input [(ngModel)]="usuario.vc_senha" class="input" type="password" id="senha" name="usuario.vc_senha">
</label>
<div id="buttons">
    <button class="btn-sucesso" type="submit" (click)="atualizar()">Editar</button>
    <button (click)="cancel()"  class="btn-cancelar" type="btn">Cancelar</button>
  </div>